/**
 * Generates a unique key string for a given value.
 *
 * @param {unknown} value - The input value to generate a key for.
 * @returns {string | number} A stringified key based on the value type and content.
 */
export function getValueKey(value) {
    if (value === undefined) {
        return 'undefined';
    }
    switch (typeof value) {
        case 'number':
        case 'string':
            return 'constant:' + value;
        default:
            return 'json:' + JSON.stringify(value);
    }
}
